// Only public pack slugs travel through sign-in and model setup URLs.
export function parsePhotoPackSlugs(value: string | string[] | undefined) {
  const values = Array.isArray(value) ? value : value?.split(',') || [];
  return [...new Set(values)]
    .filter(
      (slug) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug) && slug.length <= 100,
    )
    .slice(0, 100);
}

export function photoPackReturnPath(slugs: string[], modelId?: number | null) {
  const query = new URLSearchParams({
    photoPacks: '1',
    packs: parsePhotoPackSlugs(slugs).join(','),
  });
  if (modelId && Number.isSafeInteger(modelId) && modelId > 0)
    query.set('packModel', String(modelId));
  return `/ai-images?${query}`;
}

export function photoPackSetupPath(slugs: string[]) {
  const query = new URLSearchParams({
    photoPacks: '1',
    packs: parsePhotoPackSlugs(slugs).join(','),
  });
  return `/ai-images/models/train?${query}`;
}
